import api from '@/services/api/api'

class ExportService {
  getAllExports () {
    return api.get('export').then(result => {
      return result.data
    })
  }

  createExport (boxId, name, password, makeFolderForArtwork) {
    return api.post('export',
      {
        boxId: boxId,
        name: name,
        password: password,
        makeFolderForArtwork: makeFolderForArtwork
      })
  }

  getExportStatus (exportIdentifier) {
    return api.get('export/' + exportIdentifier + '/status').then(response => {
      return response.data
    })
  }

  openExportDownload (exportId) {
    return api.get('export/' + exportId + '/open-download').then(response => {
      return response.data
    })
  }
}

export default new ExportService()



// WEBPACK FOOTER //
// ./src/services/export/ExportService.js